import API from "core/networks/API";
import { call, put, takeLatest } from 'redux-saga/effects';
import { API_CLIENT_SETTING } from '../api';
import { GET_APP_SETTING, GET_APP_SETTING_FAILED, GET_APP_SETTING_SUCCESS } from './types';

function* getAppClientSetting(_action: any): any {
  
  try {
    const response = yield call(() => {
      const url = API_CLIENT_SETTING;
      return API.get(url, _action.payload);
    });
    const { data } = response;
    if (data?.code === 200) {
      yield put({
        type: GET_APP_SETTING_SUCCESS,
        payload: data,
      });
    }else{
      yield put({
        type: GET_APP_SETTING_FAILED,
        payload: data?.error || {},
      });
    }
  } catch (error) {
    yield put({
      type: GET_APP_SETTING_FAILED,
      payload: error || {},
    });
  }
}

function* AppSettingsaga() {
  //console.log("AppSettingsaga saga" );
  yield takeLatest(GET_APP_SETTING, getAppClientSetting);
 
}

export default AppSettingsaga;
